import './vendor';
import './helpers';
import './components/preloader';
import './components/slider';
import './components/filters';
import './components/share';
import './components/blog-slider';
import {ieFix} from './vendor/ie-fix';
import {vhFix} from './vendor/vh-fix';
import {actualYear} from './modules/actualYear';
import lazyLoading from './modules/lazyLoading';
import lightbox from 'lightbox2';

ieFix();
vhFix();
actualYear();
lazyLoading.init();

function toAnchor(position, speed = 400) {
  $(document.documentElement).add(document.body).animate({
    scrollTop: position,
  }, speed);
}

$('.js-to-ornaments').on('click', (e) => {
  if ($(document).find('.page').hasClass('home')) {
    e.preventDefault();

    if (innerWidth < 768) {
      $('.burger').removeClass('is-active');
      $('.header').removeClass('mobile-active');
      $('.header .rightside').fadeOut();
    }

    $(document.documentElement).add(document.body).animate({
      scrollTop: $('.ornaments').offset().top - $('.header').height(),
    }, 400);
  }
});

$('.home__slider__button').on('click', () => {
  toAnchor($('.home__about').offset().top - $('.header').height(), 200);
})

$('.button-up').on('click', () => {
  toAnchor($('.site').offset().top, 400);
});

$('.burger').on('click', (e) => {
  if ($(e.currentTarget).hasClass('is-active')) {
    $(e.currentTarget).removeClass('is-active');
    $('.header').removeClass('mobile-active');
    $('.header .rightside').fadeOut();
  } else {
    if ($('.filters-button').hasClass('is-active')) {
      $(document).find('.header__filters__content').slideUp();
      $('.header__filters__bg').fadeOut(250, () => {
        $('.header__filters').slideUp(250);
        $('.filters-button').removeClass('is-active');
        $(e.currentTarget).addClass('is-active');
        $('.header').addClass('mobile-active');
        $('.header .rightside').fadeIn();

        if ($(document).scrollTop() <= $('.header').height()) {
          $('.header').removeClass('is-fixed');
        }
      });
    } else {
      $(e.currentTarget).addClass('is-active');
      $('.header').addClass('mobile-active');
      $('.header .rightside').fadeIn();
    }
  }
});

if ($(document).find('.page').hasClass('article')) {
  $(document).find('.progress-bar').addClass('is-active');
}

$(document).on('scroll', () => {
  if ($(document).scrollTop() > $('.header').height() &&
    !$('.header').hasClass('is-fixed') &&
    !$('.header').hasClass('mobile-active') &&
    !$('.filters-button').hasClass('is-active')
  ) {
    $('.header').addClass('is-fixed');
  } else if ($(document).scrollTop() <= $('.header').height() &&
    $('.header').hasClass('is-fixed') &&
    !$('.filters-button').hasClass('is-active') &&
    !$('.header').hasClass('mobile-active')
  ) {
    $('.header').removeClass('is-fixed');
  }

  if ($(document).scrollTop() > 100 && !$('.button-up').hasClass('is-fixed')) {
    $('.button-up').addClass('is-fixed')
  } else if ($(document).scrollTop() <= 100 && $('.button-up').hasClass('is-fixed')) {
    $('.button-up').removeClass('is-fixed')
  }

  if ($(document).find('.page').hasClass('article')) {
    $(document).find('.progress-bar').css({
      'width': `${$(document).scrollTop() / (($(document).height() - innerHeight) / 100)}%`,
    });
  }
});

$('.item__button').on('mouseenter', (e) => {
  $(e.currentTarget).addClass('is-active');
});

$('.item__button').on('mouseleave', (e) => {
  $(e.currentTarget).removeClass('is-active');
});

if (innerWidth < 1025) {
  $(document).on('click', (e) => {
      if ($(document).find('.page').hasClass('ornament')) {
      let $downButton = $(document).find('.ornament__slider-info__download__view__down');
      let $downContent = $(document).find('.ornament__slider-info__download__content');

      if (
        !$downButton.hasClass('is-active') &&
        e.pageX >= $downButton.offset().left &&
        e.pageX <= $downButton.offset().left + $downButton.width() &&
        e.pageY >= $downButton.offset().top &&
        e.pageY <= $downButton.offset().top + $downButton.height()
      ) {
        $downButton.addClass('is-active');
        $downContent.addClass('is-active');
      } else if (
        $downButton.hasClass('is-active') &&
        (
          e.pageX < $downContent.offset().left ||
          e.pageX > $downContent.offset().left + $downContent.width() ||
          e.pageY < $downContent.offset().top ||
          e.pageY > $downContent.offset().top + $downContent.height()
        )
      ) {
        $downButton.removeClass('is-active');
        $downContent.removeClass('is-active');
      }
    }
  });
}

$(document).find('.langs li').eq(0).find('span').text('Ру');
$(document).find('.langs li').eq(1).find('span').text('O’z');

$(document).on('preloader-finish', () => {
  if ($(document).find('.page').hasClass('home') && innerWidth >= 768) {
    $('.ornaments__items').masonry({
      itemSelector: '.item',
    });
  }

  if (location.href.indexOf('scroll=true') !== -1) {
    $(document.documentElement).add(document.body).animate({
      scrollTop: $('.ornaments').offset().top - $('.header').height(),
    }, 400);
  }

  if ($(document).find('.page').hasClass('ornament') && innerWidth >= 768) {
    $('.ornament__slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      centerMode: true,
      variableWidth: true,
      slidesToShow: 1,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,
    });
  }

  if ($(document).find('.page').hasClass('blog')) {
    $('.header .nav li').eq(2).addClass('is-current');
  }

  if ($(document).find('.page').hasClass('article')) {
    $('.article__slider').slick({
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      centerMode: true,
      variableWidth: true,
      slidesToShow: 1,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,
    });

    lightbox.option({
      'resizeDuration': 0,
      'showImageNumberLabel': false,
      'fitImagesInViewport': true,
    })
  }

  if ($(document).find('.page').hasClass('about')) {
    $('.header .nav li').eq(1).addClass('is-current');

    if (innerWidth >= 768) {
      $('.about__slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        centerMode: true,
        variableWidth: true,
        slidesToShow: 1,
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false,
      });
    } else {
      $('.about__block--team__items').slick({
        dots: false,
        arrows: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false,
      });
    }

    $('.about__partners__slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 1,
          }
        },
      ],
    });
  }
});

function copyToClipboard(text) {
  let sampleTextarea = document.createElement("textarea");
  document.body.appendChild(sampleTextarea);
  sampleTextarea.value = text;
  sampleTextarea.select();
  document.execCommand("copy");
  document.body.removeChild(sampleTextarea);
}

$('[data-share="link"]').on('click', (e) => {
  e.preventDefault();

  copyToClipboard($(e.currentTarget).data('link'));
  $(e.currentTarget).find('span').addClass('is-active');

  setTimeout(() => {
    $(e.currentTarget).find('span').removeClass('is-active');
  }, 1000);
});

$('.blog__news__more .button').on('click', (e) => {
  e.preventDefault();

  const next = $(e.currentTarget).data('offset');
  $.ajax({
		method: 'post',
		dataType: 'json',
		url: ajaxUrl,
		data: {
			offset: next,
			action: 'loadMoreNews',
		},
		success(data) {
      $(document).find('.blog__news__items').append(data.posts);
      $(e.currentTarget).data('offset', data.offset).attr('data-offset', data.offset);
      if ($(document).find('.blog__news__item').length >= $('.blog__news__items').data('items')) {
        $(e.currentTarget).addClass('is-hidden');
      }
		},
	});
});

$('.ornaments .load-more .button').on('click', (e) => {
  e.preventDefault();

  $.ajax({
		method: 'post',
		dataType: 'json',
		url: ajaxUrl,
		data: {
      query: $(e.currentTarget).data('query'),
			offset: $(e.currentTarget).data('offset'),
			action: 'loadMoreOrnaments',
		},
		success(data) {
      let parent = document.createElement("div");
      parent.innerHTML = data.posts;

      const $elements = $('<div/>').html(data.posts).contents();
      if (innerWidth >= 768) {
        $(parent).find('.item').each((index, $item) => {
          setTimeout(() => {
            $('.ornaments__items').masonry()
              .append( $item )
              .masonry( 'appended', $item )
              .masonry();
            if ($(document).find('.ornaments .item').length >= $('.ornaments__items').data('items')) {
              $(e.currentTarget).addClass('is-hidden');
            }
          }, index * 50);
        })
      } else {
        $(document).find('.ornaments__items').append(data.posts);
        if ($(document).find('.ornaments .item').length >= $('.ornaments__items').data('items')) {
          $(e.currentTarget).addClass('is-hidden');
        }
      }
      $(e.currentTarget).data('offset', data.offset).attr('data-offset', data.offset);
		},
	});
});

$('.button-apply').on('click', () => {
  let $items = $(document).find('.js-filter-item.is-active');
  let url = $('.header__container').data('url');
  let lang = $('.header__container').data('lang');
  if (lang === '') {
    url+='?scroll=true';
  } else {
    url+=`${lang}&scroll=true`
  }

  $items.each((index, item) => {
    url+=`&${$(item).data('filter')}[]=${$(item).data('item')}`;
  });
  location.href = url;
});